import React from "react";
import { HInput, passParamsThrough } from "../../../../validation/HForm";

const InputField = ({
  name,
  id,
  decimals,
  readOnly,
  onClick,
  control,
  register,
  errors,
}) => {
  const props = { control, register, errors };
  return passParamsThrough(
    <div className="form-element-data number">
      <HInput
        h="true"
        className="input"
        type="text"
        name={name}
        id={id}
        decimals={decimals}
        readOnly={readOnly}
        onClick={onClick}
      />
    </div>,
    props
  );
};

const AnnuityTariffRow = ({
  number,
  isDiscountBonus,
  isDiscountBirthday,
  checkValueInput,
  isPurity,
  isThings,
  isCars,
  control,
  register,
  errors,
}) => {
  const props = { control, register, errors };
  return passParamsThrough(
    <tr className="annuity-tariff">
      <td></td>
      <td>
        <div className="table-cellcontent flex-column hybrid">
          <div className="form-row flex-nowrap">
            <div className="form-row-item">
              <InputField
                h="true"
                name={`rows[${number}].minAnnuityDuration`}
                id={`baseAnnuityStartPrice${number}`}
                decimals={2}
              />
            </div>
            <div className="form-row-item">
              <div className="form-element-data">
                <p>—</p>
              </div>
            </div>
            <div className="form-row-item">
              <InputField
                h="true"
                name={`rows[${number}].maxAnnuityDuration`}
                id={`baseAnnuityEndPrice${number}`}
                decimals={2}
              />
            </div>
          </div>
        </div>
      </td>
      <td>
        <InputField
          h="true"
          name={`rows[${number}].baseAnnuityPercentBonus`}
          id="baseAnnuityPercentBonus"
          decimals={2}
          readOnly={!isDiscountBonus}
          onClick={() => checkValueInput("baseAnnuityPercentBonus")}
        />
      </td>
      <td>
        <InputField
          h="true"
          name={`rows[${number}].baseAnnuityPercentBirthday`}
          id="baseAnnuityPercentBirthday"
          decimals={2}
          readOnly={!isDiscountBirthday}
          onClick={() => checkValueInput("baseAnnuityPercentBirthday")}
        />
      </td>
      {isPurity && (
        <td>
          <InputField
            h="true"
            name={`rows[${number}].baseAnnuityPurity`}
            id={`baseAnnuityPurity${number}`}
            decimals={2}
          />
        </td>
      )}
      {isThings && (
        <td>
          <InputField
            h="true"
            name={`rows[${number}].baseAnnuityThings`}
            id={`baseAnnuityThings${number}`}
            decimals={2}
          />
        </td>
      )}
      {isCars && (
        <td>
          <InputField
            h="true"
            name={`rows[${number}].baseAnnuityCars`}
            id={`baseAnnuityCars${number}`}
            decimals={2}
          />
        </td>
      )}
      {isPurity && (
        <td>
          <InputField
            h="true"
            name={`rows[${number}].delayAnnuityPurity`}
            id={`delayAnnuityPurity${number}`}
            decimals={2}
          />
        </td>
      )}
      {isThings && (
        <td>
          <InputField
            h="true"
            name={`rows[${number}].delayAnnuityThings`}
            id={`delayAnnuityThings${number}`}
            decimals={2}
          />
        </td>
      )}
      {isCars && (
        <td>
          <InputField
            h="true"
            name={`rows[${number}].delayAnnuityCars`}
            id={`delayAnnuityCars${number}`}
            decimals={2}
          />
        </td>
      )}
      <td></td>
    </tr>,
    props
  );
};

export default AnnuityTariffRow;
